import type { FC } from 'react'
import { joinNames } from './jointAppointment'
import { getScheduleStaffInitials } from './scheduleInstance'

// Badges that fit down a card's left edge; past this the rest fold into a count.
export const MAX_STACKED_STAFF_BADGES = 3

type StaffBadgeProvider = { id: number; name: string }

type StaffInitialsStackProps = {
  providers: StaffBadgeProvider[]
}

const BADGE = 'event-consultation-staff-initials'

// The card's doctors down its left edge, primary on top; short cards keep the primary and a count.
export const StaffInitialsStack: FC<StaffInitialsStackProps> = ({ providers }) => {
  const named = providers.filter((provider) => provider.name.trim())
  if (!named.length) return null

  const overflow = named.length > MAX_STACKED_STAFF_BADGES
  const shown = overflow ? named.slice(0, MAX_STACKED_STAFF_BADGES - 1) : named
  const hidden = named.length - shown.length

  return (
    <span
      className='event-consultation-staff-stack'
      aria-label={joinNames(named.map((p) => p.name))}>
      {shown.map((provider, slot) => (
        <span key={provider.id} className={`${BADGE} ${BADGE}--slot-${slot}`} aria-hidden>
          {getScheduleStaffInitials(provider.name)}
        </span>
      ))}
      {overflow && (
        <span className={`${BADGE} ${BADGE}--more`} aria-hidden>
          +{hidden}
        </span>
      )}
      {named.length > 1 && (
        <span className={`${BADGE} ${BADGE}--more ${BADGE}--compact`} aria-hidden>
          +{named.length - 1}
        </span>
      )}
    </span>
  )
}
